(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hk-recipe-blog"]) return;
  try {
    
document.addEventListener('submit', function(event) {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-hk-recipe-filters]')) return;
  event.preventDefault();
  const selections = [form.elements.recipe_product.value, form.elements.recipe_category.value].filter(Boolean);
  const base = form.dataset.blogUrl.replace(/\/$/, '');
  window.location.assign(base + (selections.length ? '/tagged/' + selections.map(encodeURIComponent).join('+') : ''));
});
async function refreshHofkrautRecipeCategories(form) {
  const submit = form.querySelector('button[type="submit"]');
  const product = form.elements.recipe_product.value;
  const previousCategory = form.elements.recipe_category.value;
  const requestId = String(Number(form.dataset.categoryRequest || 0) + 1);
  form.dataset.categoryRequest = requestId;
  submit.disabled = true;
  try {
    const path = form.dataset.blogUrl + (product ? '/tagged/' + encodeURIComponent(product) : '');
    const url = new URL(path, window.location.origin);
    url.searchParams.set('section_id', form.dataset.hkSectionId);
    const response = await fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(8000) });
    if (!response.ok || form.dataset.categoryRequest !== requestId) return;
    const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
    const freshForm = parsed.querySelector('[data-hk-recipe-filters]');
    if (!freshForm) return;
    const select = form.elements.recipe_category;
    select.replaceChildren(...Array.from(freshForm.elements.recipe_category.options).map(function(option) { return option.cloneNode(true); }));
    select.value = Array.from(select.options).some(function(option) { return option.value === previousCategory; }) ? previousCategory : '';
  } catch (error) {} finally {
    if (form.dataset.categoryRequest === requestId) submit.disabled = false;
  }
}
document.addEventListener('change', function(event) {
  if (event.target.matches('[data-hk-recipe-filters] select[name="recipe_product"]')) {
    refreshHofkrautRecipeCategories(event.target.form);
  }
});

function initHofkrautRecipeFilters(root) {
  if (!window.location.pathname.includes('/tagged/')) return;
  root.querySelectorAll('[data-hk-recipe-filters]').forEach(async function(form) {
    if (form.dataset.optionsLoaded) return;
    form.dataset.optionsLoaded = 'true';
    try {
      const url = new URL(form.dataset.blogUrl, window.location.origin);
      url.searchParams.set('section_id', form.dataset.hkSectionId);
      const response = await fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(8000) });
      if (!response.ok) return;
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const freshForm = documentFragment.querySelector('[data-hk-recipe-filters]');
      if (!freshForm) return;
      ['recipe_product'].forEach(function(name) {
        const select = form.elements.namedItem(name);
        const freshSelect = freshForm.elements.namedItem(name);
        const selectedValue = select.value;
        select.replaceChildren(...Array.from(freshSelect.options).map(function(option) { return option.cloneNode(true); }));
        select.value = selectedValue;
      });
      refreshHofkrautRecipeCategories(form);
    } catch (error) {}
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { initHofkrautRecipeFilters(document); });
} else { initHofkrautRecipeFilters(document); }
document.addEventListener('shopify:section:load', function(event) { initHofkrautRecipeFilters(event.target); });

  } catch(e) { console.error(e); }
})();
})();
